import usePageContentEditor from "../../hooks/usePageContentEditor";
import PageContentEditor from "./PageContentEditor";

export default function PageContentManager({ pages, onRefresh }) {
  const editor = usePageContentEditor(pages, onRefresh);

  return (
    <section className="admin-section content-manager" data-testid="admin-page-content-manager">
      <div className="admin-section-heading"><div><span className="eyebrow">Public website</span><h2>PAGE CONTENT</h2></div></div>
      <PageContentEditor editor={editor} />
    </section>
  );
}